import { TravelRequestInput } from './interface';

export class GetAllRequests {
    static readonly type = '[TravelRequest] all';
    constructor(
        public queryParams?: {
            formTitle?: string;
        }
    ) {}
}

export class CreateTravelForm {
    static readonly type = '[TravelRequest] create travel-form';
    constructor(public input: TravelRequestInput) {}
}

export class GetSingleTravelRequest {
    static readonly type = '[TravelRequest] get-one';
    constructor(public id: string) {}
}
export class GetTravelRequestByUser {
    static readonly type = '[TravelRequest] get-by-user';
    constructor(public input: { id: string; query: string }) {}
}
export class GetTravelRequestByApprovers {
    static readonly type = '[TravelRequest] approvers';
    constructor(public input: { id: string; query: string }) {}
}
